import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

type Range = [number, number];

@Component({
	inheritAttrs: false
})
export class WmsRangeSlider extends Vue {
	@Prop() value: any;

	@Prop() min: number;
	@Prop() max: number;
	@Prop() interval: number;
	@Prop() multiplier: number;
	@Prop() piecewise: boolean;
	@Prop() piecewiseLabel: boolean;
	@Prop() tooltip: boolean;
	@Prop() tooltipDir: any[];
	@Prop() data: any[];
	@Prop() defaultValue: number;

	sliderValue: number = this.value || 0;

	get sliderOptions() {
		return {
			height: 4,
			dotSize: 17,
			enableCross: false,
			min: this.min || 0,
			max: this.max || 100,
			interval: this.interval || 1,
			piecewise: this.piecewise,
			piecewiseLabel: this.piecewiseLabel,
			tooltip: this.tooltip || (!this.piecewise && 'always'),
			data: this.data,
			lazy: false,
			tooltipDir: this.tooltipDir || 'top',
		};
	}

	getTooltipScope(originalScope: any, index: number) {
		return {
			value: originalScope.value[index],
			index,
			merge: originalScope.value[0] !== originalScope.value[1],
			single: originalScope.value[0] === originalScope.value[1]
		}
	}

	get valueSlide() {
		return this.value === undefined ? (this.defaultValue || this.min) : this.value;
	}

}

export default WmsRangeSlider;
